exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.v-datatable.v-table tbody td[data-v-ddc18366],table.v-datatable.v-table tfoot td[data-v-ddc18366],table.v-datatable.v-table thead th[data-v-ddc18366]{padding:0;border-left:1px solid rgba(0,0,0,.12);border-right:1px solid rgba(0,0,0,.12)}.pagina-progreso[data-v-ddc18366]{position:absolute!important;margin:0;bottom:0;left:0}.scroll[data-v-ddc18366]{overflow-y:auto;max-height:300px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ddc18366","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/indicadores/costo2.vue
// module id = RpgZ
// module chunks = 0